package us.laantech.laanmanage.feature.store.settings

import androidx.compose.foundation.layout.Column
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.lifecycle.compose.collectAsStateWithLifecycle

@Composable
fun StoreSettingsView(
    viewModel: StoreSettingsViewModel = StoreSettingsViewModel(),
    modifier: Modifier = Modifier
) {

    val uiState = viewModel.uiState.collectAsStateWithLifecycle()

    Column(modifier=modifier) {

        Text("Store Settings")
        Text("Department: ${uiState.value.department}")
    
    }

}